export default __webpack_public_path__ + "static/media/Power.29814f04.svg";